import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "calender-add, date-add" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "Vector" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 2.00016C6 1.63197 5.70152 1.3335 5.33333 1.3335C4.96514 1.3335 4.66667 1.63197 4.66667 2.00016V2.66683H4C2.89543 2.66683 2 3.56226 2 4.66683V12.0002C2 13.1047 2.89543 14.0002 4 14.0002H7.33333C7.70152 14.0002 8 13.7017 8 13.3335C8 12.9653 7.70152 12.6668 7.33333 12.6668H4C3.63181 12.6668 3.33333 12.3684 3.33333 12.0002V6.66683H12.6667V7.3335C12.6667 7.70169 12.9651 8.00016 13.3333 8.00016C13.7015 8.00016 14 7.70169 14 7.3335V4.66683C14 3.56226 13.1046 2.66683 12 2.66683H11.3333V2.00016C11.3333 1.63197 11.0349 1.3335 10.6667 1.3335C10.2985 1.3335 10 1.63197 10 2.00016V2.66683H6V2.00016Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.6667 10.0002C12.6667 9.63197 12.3682 9.3335 12 9.3335C11.6318 9.3335 11.3333 9.63197 11.3333 10.0002V11.3335H10C9.63181 11.3335 9.33333 11.632 9.33333 12.0002C9.33333 12.3684 9.63181 12.6668 10 12.6668H11.3333V14.0002C11.3333 14.3684 11.6318 14.6668 12 14.6668C12.3682 14.6668 12.6667 14.3684 12.6667 14.0002V12.6668H14C14.3682 12.6668 14.6667 12.3684 14.6667 12.0002C14.6667 11.632 14.3682 11.3335 14 11.3335H12.6667V10.0002Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }